import {
  Box,
  Button,
  Stack,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import {
  bgColor31,
  blackShade19,
  blueColor04,
  borderTextBoxColor,
  greenStatusColor01,
  greyColor060,
  greyColor42,
  greyColor53,
  greyColor54,
  greyColor56,
  lightgreenColor04,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import ModalCard from "../../../components/ModalCard";
import AllSellingProducts from "../Cards/AllSellingProducts";

function ProductSellingSection({ products }) {
  const [viewMore, setViewMore] = useState(false);
  return (
    <Stack
      sx={{
        border: "1px solid " + greyColor56,
        borderRadius: "12px",
        overflow: "hidden",
      }}
      minHeight={"100%"}
    >
      <ModalCard
        open={viewMore}
        handleClose={() => setViewMore(false)}
        width="50%"
      >
        <AllSellingProducts products={products} />
      </ModalCard>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        sx={{ p: "12px 14px" }}
      >
        <Typography
          fontSize={13.5}
          fontWeight={600}
          color={blackShade19}
          lineHeight="20px"
        >
          Top Selling Products
        </Typography>
        {products?.length > 5 && (
          <Typography
            fontSize={11}
            fontWeight={500}
            color={blueColor04}
            component={Button}
            lineHeight={1.5}
            sx={{
              textDecoration: "underline",
              textTransform: "none",
              p: "0px",
              "&:hover": { background: "transparent" },
            }}
            onClick={() => setViewMore(true)}
          >
            View More
          </Typography>
        )}
      </Box>

      <Box sx={styles.tableWrapper}>
        <TableContainer sx={styles.tableContainer} component={Box}>
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  position: "sticky !important",
                  top: 0,
                  backgroundColor: greyColor53,
                  zIndex: 20,
                }}
              >
                <TableCell
                  sx={{ ...styles.tableCell, width: "80%" }}
                  align="center"
                >
                  Product
                </TableCell>
                <TableCell sx={styles.tableCell} align="center">
                  Units sold
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {products?.slice(0, 4)?.map((product, index) => (
                <TableRow
                  sx={{
                    borderBottom: `1px solid ${borderTextBoxColor}`,
                    verticalAlign: "top",
                    backgroundColor: index % 2 == 0 ? whiteColor : bgColor31,
                  }}
                  key={product?.id}
                >
                  <TableCell sx={{ ...styles.tableBodyCell, maxWidth: "80%" }}>
                    <Box display="flex" gap="12px">
                      <Box
                        component="img"
                        src={product?.productInfo?.productPhoto?.docURL}
                        sx={{
                          width: "35px",
                          height: "35px",
                          p: "3px",
                          border: "1px solid #e5e9f0",
                          borderRadius: "5px",
                        }}
                      />
                      <Box sx={{ maxWidth: "calc(100% - 50px)" }}>
                        <Typography
                          sx={{
                            wordBreak: "break-word",
                            whiteSpace: "normal",
                            fontSize: 11.5,
                            fontWeight: 600,
                            color: blackShade19,
                            lineHeight: "16px",
                            display: "-webkit-box", // Enables multi-line ellipsis
                            WebkitLineClamp: 2, // Limits to 2 lines
                            WebkitBoxOrient: "vertical", // Vertical box orientation
                            overflow: "hidden",
                          }}
                          title={product?.productName}
                        >
                          {product?.productName}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <Box
                      sx={{
                        fontWeight: 500,
                        fontSize: "12px",
                        color: greenStatusColor01,
                        textAlign: "center",
                        background: lightgreenColor04,
                        padding: "2px 4px",
                        width: "40px",
                        borderRadius: "4px",
                        mt: "4px",
                      }}
                    >
                      {product?.totalQuantity}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Stack>
  );
}

export default ProductSellingSection;

const styles = {
  tableWrapper: {
    width: "100%",
    // border: `1px solid ${borderTextBoxColor}`,
    borderBottom: "none",
    overflow: "hidden",
  },

  tableContainer: {
    maxWidth: "100%",
  },

  tableCell: {
    color: greyColor060,
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "16px",
    whiteSpace: "nowrap",
    padding: "8px 15px",
    backgroundColor: greyColor53,
    textAlign: "start",
    // borderRight: `1px solid ${whiteColor}`,
  },

  tableBodyCell: {
    fontSize: 12,
    fontWeight: 600,
    lineHeight: "16px",
    whiteSpace: "nowrap",
    color: blackShade19,
    padding: "10px 15px !important",
    textAlign: "start",
  },
};
